import { z } from "zod";

/**
 * Zod schema for runtime validation of TPRA Summary API response
 * This ensures the backend contract matches our TypeScript types
 */

export const RiskDistributionSchema = z.object({
  high: z.number().int().nonnegative(),
  medium: z.number().int().nonnegative(),
  low: z.number().int().nonnegative(),
  pending: z.number().int().nonnegative(),
});

export const IssueDistributionSchema = z.object({
  critical: z.number().int().nonnegative(),
  high: z.number().int().nonnegative(),
  medium: z.number().int().nonnegative(),
  low: z.number().int().nonnegative(),
});

export const VendorRiskTrendItemSchema = z.object({
  month: z.string().regex(/^\d{4}-\d{2}$/, "Month must be in format YYYY-MM"),
  all_vendors: z.number().int().nonnegative(),
  high: z.number().int().nonnegative(),
  medium: z.number().int().nonnegative(),
  low: z.number().int().nonnegative(),
  pending: z.number().int().nonnegative().optional().default(0), // Optional with default
});

export const BreachTrendItemSchema = z.object({
  month: z.string().regex(/^\d{4}-\d{2}$/, "Month must be in format YYYY-MM"),
  breach_count: z.number().int().nonnegative(),
});

export const AssessmentStagesSchema = z.object({
  intake_form: z.number().int().nonnegative(),
  due_diligence: z.number().int().nonnegative(),
  review: z.number().int().nonnegative(),
  reassessment: z.number().int().nonnegative(),
  complete: z.number().int().nonnegative(),
});

export const TPRASummaryResponseSchema = z.object({
  success: z.boolean(),
  total_vendors: z.number().int().nonnegative(),
  vendors_with_incidents: z.number().int().nonnegative(),
  vendors_critical_business_impact: z.number().int().nonnegative(),
  issue_distribution: IssueDistributionSchema,
  risk_distribution: RiskDistributionSchema,
  vendor_risk_trend: z.array(VendorRiskTrendItemSchema),
  breach_trend: z.array(BreachTrendItemSchema),
  assessment_stages: AssessmentStagesSchema,
});

export type TPRASummaryResponseValidated = z.infer<typeof TPRASummaryResponseSchema>;
